import { default as _91_46_46_46slugs_93g6LkNx6JdEMeta } from "/Users/esaia/Desktop/projects/gumbati-nuxt/pages/[...slugs].vue?macro=true";
import { default as clear_45cachesBFovBdoGQMeta } from "/Users/esaia/Desktop/projects/gumbati-nuxt/pages/clear-cache.vue?macro=true";
import { default as errorgTkCoAAPkBMeta } from "/Users/esaia/Desktop/projects/gumbati-nuxt/pages/error.vue?macro=true";
import { default as indexXnP09Elx45Meta } from "/Users/esaia/Desktop/projects/gumbati-nuxt/pages/index.vue?macro=true";
import { default as privacy_45policy_45test2EFWIkzftJMeta } from "/Users/esaia/Desktop/projects/gumbati-nuxt/pages/privacy-policy-test.vue?macro=true";
export default [
  {
    name: _91_46_46_46slugs_93g6LkNx6JdEMeta?.name ?? "slugs___ka",
    path: _91_46_46_46slugs_93g6LkNx6JdEMeta?.path ?? "/ka/:slugs(.*)*",
    meta: _91_46_46_46slugs_93g6LkNx6JdEMeta || {},
    alias: _91_46_46_46slugs_93g6LkNx6JdEMeta?.alias || [],
    redirect: _91_46_46_46slugs_93g6LkNx6JdEMeta?.redirect || undefined,
    component: () => import("/Users/esaia/Desktop/projects/gumbati-nuxt/pages/[...slugs].vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slugs_93g6LkNx6JdEMeta?.name ?? "slugs___en",
    path: _91_46_46_46slugs_93g6LkNx6JdEMeta?.path ?? "/:slugs(.*)*",
    meta: _91_46_46_46slugs_93g6LkNx6JdEMeta || {},
    alias: _91_46_46_46slugs_93g6LkNx6JdEMeta?.alias || [],
    redirect: _91_46_46_46slugs_93g6LkNx6JdEMeta?.redirect || undefined,
    component: () => import("/Users/esaia/Desktop/projects/gumbati-nuxt/pages/[...slugs].vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slugs_93g6LkNx6JdEMeta?.name ?? "slugs___ru",
    path: _91_46_46_46slugs_93g6LkNx6JdEMeta?.path ?? "/ru/:slugs(.*)*",
    meta: _91_46_46_46slugs_93g6LkNx6JdEMeta || {},
    alias: _91_46_46_46slugs_93g6LkNx6JdEMeta?.alias || [],
    redirect: _91_46_46_46slugs_93g6LkNx6JdEMeta?.redirect || undefined,
    component: () => import("/Users/esaia/Desktop/projects/gumbati-nuxt/pages/[...slugs].vue").then(m => m.default || m)
  },
  {
    name: clear_45cachesBFovBdoGQMeta?.name ?? "clear-cache___ka",
    path: clear_45cachesBFovBdoGQMeta?.path ?? "/ka/clear-cache",
    meta: clear_45cachesBFovBdoGQMeta || {},
    alias: clear_45cachesBFovBdoGQMeta?.alias || [],
    redirect: clear_45cachesBFovBdoGQMeta?.redirect || undefined,
    component: () => import("/Users/esaia/Desktop/projects/gumbati-nuxt/pages/clear-cache.vue").then(m => m.default || m)
  },
  {
    name: clear_45cachesBFovBdoGQMeta?.name ?? "clear-cache___en",
    path: clear_45cachesBFovBdoGQMeta?.path ?? "/clear-cache",
    meta: clear_45cachesBFovBdoGQMeta || {},
    alias: clear_45cachesBFovBdoGQMeta?.alias || [],
    redirect: clear_45cachesBFovBdoGQMeta?.redirect || undefined,
    component: () => import("/Users/esaia/Desktop/projects/gumbati-nuxt/pages/clear-cache.vue").then(m => m.default || m)
  },
  {
    name: clear_45cachesBFovBdoGQMeta?.name ?? "clear-cache___ru",
    path: clear_45cachesBFovBdoGQMeta?.path ?? "/ru/clear-cache",
    meta: clear_45cachesBFovBdoGQMeta || {},
    alias: clear_45cachesBFovBdoGQMeta?.alias || [],
    redirect: clear_45cachesBFovBdoGQMeta?.redirect || undefined,
    component: () => import("/Users/esaia/Desktop/projects/gumbati-nuxt/pages/clear-cache.vue").then(m => m.default || m)
  },
  {
    name: errorgTkCoAAPkBMeta?.name ?? "error___ka",
    path: errorgTkCoAAPkBMeta?.path ?? "/ka/error",
    meta: errorgTkCoAAPkBMeta || {},
    alias: errorgTkCoAAPkBMeta?.alias || [],
    redirect: errorgTkCoAAPkBMeta?.redirect || undefined,
    component: () => import("/Users/esaia/Desktop/projects/gumbati-nuxt/pages/error.vue").then(m => m.default || m)
  },
  {
    name: errorgTkCoAAPkBMeta?.name ?? "error___en",
    path: errorgTkCoAAPkBMeta?.path ?? "/error",
    meta: errorgTkCoAAPkBMeta || {},
    alias: errorgTkCoAAPkBMeta?.alias || [],
    redirect: errorgTkCoAAPkBMeta?.redirect || undefined,
    component: () => import("/Users/esaia/Desktop/projects/gumbati-nuxt/pages/error.vue").then(m => m.default || m)
  },
  {
    name: errorgTkCoAAPkBMeta?.name ?? "error___ru",
    path: errorgTkCoAAPkBMeta?.path ?? "/ru/error",
    meta: errorgTkCoAAPkBMeta || {},
    alias: errorgTkCoAAPkBMeta?.alias || [],
    redirect: errorgTkCoAAPkBMeta?.redirect || undefined,
    component: () => import("/Users/esaia/Desktop/projects/gumbati-nuxt/pages/error.vue").then(m => m.default || m)
  },
  {
    name: indexXnP09Elx45Meta?.name ?? "index___ka",
    path: indexXnP09Elx45Meta?.path ?? "/ka",
    meta: indexXnP09Elx45Meta || {},
    alias: indexXnP09Elx45Meta?.alias || [],
    redirect: indexXnP09Elx45Meta?.redirect || undefined,
    component: () => import("/Users/esaia/Desktop/projects/gumbati-nuxt/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexXnP09Elx45Meta?.name ?? "index___en",
    path: indexXnP09Elx45Meta?.path ?? "/",
    meta: indexXnP09Elx45Meta || {},
    alias: indexXnP09Elx45Meta?.alias || [],
    redirect: indexXnP09Elx45Meta?.redirect || undefined,
    component: () => import("/Users/esaia/Desktop/projects/gumbati-nuxt/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexXnP09Elx45Meta?.name ?? "index___ru",
    path: indexXnP09Elx45Meta?.path ?? "/ru",
    meta: indexXnP09Elx45Meta || {},
    alias: indexXnP09Elx45Meta?.alias || [],
    redirect: indexXnP09Elx45Meta?.redirect || undefined,
    component: () => import("/Users/esaia/Desktop/projects/gumbati-nuxt/pages/index.vue").then(m => m.default || m)
  },
  {
    name: privacy_45policy_45test2EFWIkzftJMeta?.name ?? "privacy-policy-test___ka",
    path: privacy_45policy_45test2EFWIkzftJMeta?.path ?? "/ka/privacy-policy-test",
    meta: privacy_45policy_45test2EFWIkzftJMeta || {},
    alias: privacy_45policy_45test2EFWIkzftJMeta?.alias || [],
    redirect: privacy_45policy_45test2EFWIkzftJMeta?.redirect || undefined,
    component: () => import("/Users/esaia/Desktop/projects/gumbati-nuxt/pages/privacy-policy-test.vue").then(m => m.default || m)
  },
  {
    name: privacy_45policy_45test2EFWIkzftJMeta?.name ?? "privacy-policy-test___en",
    path: privacy_45policy_45test2EFWIkzftJMeta?.path ?? "/privacy-policy-test",
    meta: privacy_45policy_45test2EFWIkzftJMeta || {},
    alias: privacy_45policy_45test2EFWIkzftJMeta?.alias || [],
    redirect: privacy_45policy_45test2EFWIkzftJMeta?.redirect || undefined,
    component: () => import("/Users/esaia/Desktop/projects/gumbati-nuxt/pages/privacy-policy-test.vue").then(m => m.default || m)
  },
  {
    name: privacy_45policy_45test2EFWIkzftJMeta?.name ?? "privacy-policy-test___ru",
    path: privacy_45policy_45test2EFWIkzftJMeta?.path ?? "/ru/privacy-policy-test",
    meta: privacy_45policy_45test2EFWIkzftJMeta || {},
    alias: privacy_45policy_45test2EFWIkzftJMeta?.alias || [],
    redirect: privacy_45policy_45test2EFWIkzftJMeta?.redirect || undefined,
    component: () => import("/Users/esaia/Desktop/projects/gumbati-nuxt/pages/privacy-policy-test.vue").then(m => m.default || m)
  }
]